import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";

import { Link, useLocation } from "react-router-dom";

export default () => {
  const moduleName = "products";
  const dispatch = useDispatch();
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  useEffect(() => {
    dispatch(actions.list("brands/user"));
    dispatch(actions.list("product_categories/user"));
  }, []);

  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0)
  const [brandOptions, setBrandOptions] = useState([])

  const location = useLocation()

  useEffect( () => {
    dispatch(actions.list("brands/option"));
  }, [])

  useEffect(() => {
    dispatch(actions.list("products/user", location.search));
  }, [appReducer.products_publish, appReducer.products_unpublish, location])

  useEffect(() => {
    if(appReducer.brands_option_list != undefined){
      setBrandOptions(appReducer.brands_option_list.data)
    }
    if (appReducer.products_user_list != undefined) {
      setRows(appReducer.products_user_list.data)
      setTotalPages(appReducer.products_user_list.count)
    }
  }, [appReducer])

  const handlePublish = id => dispatch(actions.publish(id, moduleName));
  const handleUnPublish = id => dispatch(actions.unpublish(id, moduleName));


  const columns = [
    {
      name: 'تصویر',
      selector: row => row.images.length ? <img className=" w-16" src={row.images[0].url_full} /> : "-",
    },
    {
      width: "250px",
      name: 'نام',
      selector: row => row.name
    },
    {
      name: 'گروه',
      selector: row => row.category
    },
    {
      name: 'کد محصول',
      selector: row => row.code
    },
    {
      name: 'تنوع قیمت بر اساس',
      selector: row => row.attribute ? <div className=" bg-purple-200 text-purple-700 text-xs  py-3 px-4 border border-neutral-200 rounded-xl">{row.attribute}</div> : "-"
    },
    {
      name: 'نوع',
      selector: row => row.type == "consumable" ? "قابل‌فروش" : "به‌زودی",
    },
    {
      name: 'برند',
      selector: row => row.brand ?? "-",
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      width: "450px",
      selector: row => <div className="flex py-4 gap-3">
        <Link to={`/products/create/${row.id}`} className="bg-gradient-to-tr from-teal-300 to-teal-400 hover:opacity-75 border text-xs  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700 ">ویرایش و تصاویر</Link>
        <Link to={`/products/price/${row.id}`} className="bg-gradient-to-tr from-blue-300 to-blue-400 hover:opacity-75 border text-xs  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700 ">افزودن تنوع</Link>
        <Link to={`/products/comment/${row.id}`} className="bg-gradient-to-tr from-purple-300 to-purple-400 hover:opacity-75 border text-xs  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700 ">نظرات</Link>
        {row.state != "active" ? (
          <Template.Button
            onClick={() => handlePublish(row.id)}
            label="انتشار"
            background="bg-gradient-to-tr from-green-300 to-green-400  text-xs"
          />
        ) : (
          <Template.Button
            onClick={() => handleUnPublish(row.id)}
            label="عدم‌انتشار"
            background="bg-gradient-to-tr from-red-300 to-red-400  text-xs"
          />
        )}
      </div>,
    }

  ];

  return <div>
    <Template.Filter moduleName={moduleName}>
      <Template.Input label="نام" name="name" type="text" />
      <Template.SingleSelect
        placeholder="انتخاب برند"
        name="brand_id"
        withLabel={true}
        options={brandOptions}
      />
    </Template.Filter>
    <Template.Table count={totalPages} columns={columns} data={rows} />
  </div>


};
